import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=41774425"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41774425')) {
      api.createRecord('41774425', component.options)
    } else {
      api.reload('41774425', component.options)
    }
    module.hot.accept("./ProductDetail.vue?vue&type=template&id=41774425", function () {
      api.rerender('41774425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/productdetail/assets/frontend/vue/ProductDetail.vue"
export default component.exports